export default "__VITE_ASSET__BThYZVCs__"